import { chat } from "./drivers/chat.driver";
import { chatbot } from "./drivers/chatbot.driver";


export const Api = {
    chat,
    chatbot
}